export default __webpack_public_path__ + "static/media/bxl-php.d0ab9f62.svg";